import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'app-edit-well',
  templateUrl: './edit-well.component.html',
  styleUrls: ['./edit-well.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditWellComponent implements OnInit {
  panelOpenState = false;
  postErrorMessages = [];
  showProgressBar = false;
  showTribalLandName:boolean = false;
  wellViewModel = this.oregonWellDataService.wellViewModel;

  constructor(public oregonWellDataService: OregonWellDataService, 
    public authService: AuthService, private route: ActivatedRoute, private router: Router) {

      this.wellViewModel.id = Number(this.route.snapshot.paramMap.get("id"));
  }

  ngOnInit(): void {
    this.oregonWellDataService.GetEditWell(this.wellViewModel.id).subscribe(result => {
      this.wellViewModel = result;
      this.setFormValues();
    },
      error => {
        this.oregonWellDataService.onHttpError(error);
      }
    );

    this.authService.isReadOnly();
  }

  wellForm = new FormGroup({
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    zip: new FormControl(''),
    county: new FormControl(''),
    tag: new FormControl(''),
    wellLog: new FormControl(''),
    wellType: new FormControl({value: '', disabled: true}),
    latitude: new FormControl({value: '', disabled: true}),
    longitude: new FormControl({value: '', disabled: true}),
    overrideLatLong: new FormControl(),
    datum: new FormControl({value: '', disabled: true}),
    coordinateCollectionMethod: new FormControl({value: '', disabled: true}),
    monitoringLocationSourceMapScale: new FormControl(''),
    monitoringLocationDescription: new FormControl(''),
    monitoringLocationComments: new FormControl(''),
    tribalLand: new FormControl(),
    tribalLandName: new FormControl({value: '', disabled: true}),
    depth: new FormControl(''),
    samplePoint: new FormControl(''),
    monitoringLocationId: new FormControl(''),
    monitoringLocationName: new FormControl(''),
    holeDepth: new FormControl(''),
    comment: new FormControl(''),
    township: new FormControl(''),
    range: new FormControl(''),
    section: new FormControl(''),
    taxLot: new FormControl(''),
    dateWellEstablished: new FormControl(new Date()),
    createDate: new FormControl(''),
    decommissioned: new FormControl(),
    dateDecommissioned: new FormControl('')
  });

  setFormValues() {
    this.wellForm.patchValue({
      address1: this.wellViewModel.address1,
      address2: this.wellViewModel.address2,
      city: this.wellViewModel.city,
      state: this.wellViewModel.state,
      zip: this.wellViewModel.zip,
      county: this.wellViewModel.county,
      tag: this.wellViewModel.tag,
      wellLog: this.wellViewModel.wellLog,
      wellType: "Water Supply",
      overrideLatLong: this.wellViewModel.overrideLatLong,
      latitude: this.wellViewModel.latitude.toString(),
      longitude: this.wellViewModel.longitude.toString(),
      monitoringLocationSourceMapScale: this.wellViewModel.monitoringLocationSourceMapScale,
      monitoringLocationDescription: this.wellViewModel.monitoringLocationDescription,
      monitoringLocationComments: this.wellViewModel.monitoringLocationComments,
      tribalLand: this.wellViewModel.tribalLand,
      tribalLandName: this.wellViewModel.tribalLandName,
      datum: "NAD83",
      coordinateCollectionMethod: "LAMBERT CONIC CONFORMAL",
      depth: this.wellViewModel.depth,
      samplePoint: this.wellViewModel.samplePoint,
      monitoringLocationId: this.wellViewModel.monitoringLocationId,
      monitoringLocationName: this.wellViewModel.monitoringLocationName,
      comment: this.wellViewModel.comment,
      township: this.wellViewModel.township,
      range: this.wellViewModel.range,
      section: this.wellViewModel.section,
      taxLot: this.wellViewModel.taxLot,
      createDate: this.wellViewModel.createDate,
      decommissioned: this.wellViewModel.decommissioned != null ? (this.wellViewModel.decommissioned == true ? 'Yes' : 'No') : 'No',
      dateDecommissioned: this.wellViewModel.dateDecommissioned
    });

    this.wellForm.get("dateWellEstablished").setValue((new Date(this.wellViewModel.dateWellEstablished)));

    if(this.wellViewModel.overrideLatLong){
      this.wellForm.controls['latitude'].enable();
      this.wellForm.controls['longitude'].enable();
    }

    if(this.wellViewModel.tribalLand){
      this.wellForm.controls['tribalLandName'].enable();
      this.showTribalLandName = true;
    }
  }

  getFormValues() {
    this.oregonWellDataService.wellViewModel.address1 = this.wellForm.value.address1;
    this.oregonWellDataService.wellViewModel.address2 = this.wellForm.value.address2;
    this.oregonWellDataService.wellViewModel.city = this.wellForm.value.city;
    this.oregonWellDataService.wellViewModel.state = this.wellForm.value.state;
    this.oregonWellDataService.wellViewModel.zip = this.wellForm.value.zip;
    this.oregonWellDataService.wellViewModel.county = this.wellForm.value.county;
    this.oregonWellDataService.wellViewModel.tag = this.wellForm.value.tag;
    this.oregonWellDataService.wellViewModel.wellLog = this.wellForm.value.wellLog;
    this.oregonWellDataService.wellViewModel.wellType = this.wellForm.getRawValue().wellType;
    this.oregonWellDataService.wellViewModel.overrideLatLong = this.wellForm.value.overrideLatLong;
    this.oregonWellDataService.wellViewModel.latitude = this.wellForm.getRawValue().latitude != null ?  this.wellForm.getRawValue().latitude : '0';
    this.oregonWellDataService.wellViewModel.longitude = this.wellForm.getRawValue().longitude != null ?  this.wellForm.getRawValue().longitude : '0';
    this.oregonWellDataService.wellViewModel.datum = this.wellForm.getRawValue().datum;
    this.oregonWellDataService.wellViewModel.coordinateCollectionMethod = this.wellForm.getRawValue().coordinateCollectionMethod;
    this.oregonWellDataService.wellViewModel.monitoringLocationSourceMapScale = this.wellForm.value.monitoringLocationSourceMapScale;
    this.oregonWellDataService.wellViewModel.monitoringLocationDescription = this.wellForm.value.monitoringLocationDescription;
    this.oregonWellDataService.wellViewModel.monitoringLocationComments = this.wellForm.value.monitoringLocationComments;
    this.oregonWellDataService.wellViewModel.tribalLand = this.wellForm.value.tribalLand;
    this.oregonWellDataService.wellViewModel.tribalLandName = this.wellForm.value.tribalLandName;
    this.oregonWellDataService.wellViewModel.depth = this.wellForm.value.depth;
    this.oregonWellDataService.wellViewModel.samplePoint = this.wellForm.value.samplePoint;
    this.oregonWellDataService.wellViewModel.monitoringLocationId = this.wellForm.value.monitoringLocationId;
    this.oregonWellDataService.wellViewModel.monitoringLocationName = this.wellForm.value.monitoringLocationName;
    this.oregonWellDataService.wellViewModel.comment = this.wellForm.value.comment;
    this.oregonWellDataService.wellViewModel.township = this.wellForm.value.township;
    this.oregonWellDataService.wellViewModel.range = this.wellForm.value.range;
    this.oregonWellDataService.wellViewModel.section = this.wellForm.value.section;
    this.oregonWellDataService.wellViewModel.taxLot = this.wellForm.value.taxLot;
    this.oregonWellDataService.wellViewModel.decommissioned = this.wellForm.value.decommissioned != null ? (this.wellForm.value.decommissioned == 'Yes' ? true : false) : false;
    this.oregonWellDataService.wellViewModel.dateDecommissioned = this.wellForm.value.dateDecommissioned;
    
    if(this.wellForm.value.dateWellEstablished.toString() == "Invalid Date" 
        || this.wellForm.value.dateWellEstablished.toString() == '' 
        || this.wellForm.value.dateWellEstablished == null)
    {
      this.wellForm.controls['dateWellEstablished'].setValue(null);
      this.oregonWellDataService.wellViewModel.dateWellEstablished = null;
    }   
    else {
      this.oregonWellDataService.wellViewModel.dateWellEstablished = new Date(this.wellForm.value.dateWellEstablished);
    }

    this.oregonWellDataService.wellViewModel.createDate = this.wellForm.value.createDate;
    this.oregonWellDataService.wellViewModel.lastUpdatedBy = this.authService.username;
  }

  lookupCountyLatLong() {
    this.showProgressBar = true;

    if (this.wellForm.value.address1.length != 0) {
      this.oregonWellDataService.lookupCountyLatLong(
        this.wellForm.value.address1 + "," + this.wellForm.value.city + "," + this.wellForm.value.zip).subscribe(result => {
          this.wellForm.patchValue({
            county: result[3]
          });

          this.wellForm.patchValue({
            latitude: result[5],
            longitude: result[4],
          });
          this.showProgressBar = false;
        },
          error => {
            this.showProgressBar = false;
            this.oregonWellDataService.onHttpError(error);
          }
        );
    }
  }

  onSubmit() {
    this.getFormValues();
    this.oregonWellDataService.EditWell(this.oregonWellDataService.wellViewModel).subscribe(
      result => {
        this.oregonWellDataService.showToastSucess("Well Id " + result.id + " was Updated");
        this.router.navigate(['/well/edit/' + result.id]);
      },
      error => {
        this.postErrorMessages = this.oregonWellDataService.onHttpError(error);
      },
      () => {
        this.oregonWellDataService.GetEditWell(this.oregonWellDataService.wellViewModel.id).subscribe(result => {
          this.wellViewModel = result;
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
          }
        );
      }
    );
  }

  overrideLatLong() {
    var latitude = this.wellForm.controls['latitude'];
    var longitude = this.wellForm.controls['longitude'];
 
    if (latitude.disabled || longitude.disabled) {
      latitude.enable();
      longitude.enable();
    }
    else if (latitude.enabled || longitude.enabled) {
      latitude.disable();
      longitude.disable();
    }
  }

  updateTribalLand(){
    var tribalLandName = this.wellForm.controls['tribalLandName'];
    
    if (tribalLandName.disabled) {
      tribalLandName.enable();
      this.showTribalLandName = true;
    }
    else if (tribalLandName.enabled) {
      tribalLandName.disable();
      this.showTribalLandName = false;
    } 
  }
}